import { forwardRef } from 'react';
import { VariantProps, cva } from 'class-variance-authority';
import { Loader2 } from 'lucide-react';

import { cn } from '@/utils/tailwind';

const buttonVariants = cva(
  'Body3S15 inline-flex items-center justify-center text-white rounded-[12px] text-white transition-colors disabled:transition-none focus-visible:outline-none whitespace-nowrap',
  {
    variants: {
      variant: {
        default: 'bg-point-500 hover:bg-point-400 disabled:bg-gr-200 active:bg-point-500',
        secondary:
          'bg-gr-50 text-gr-700  hover:bg-gr-200 active:bg-gr-100 disabled:bg-gr-200 disabled:text-white',
        ghost: 'text-gr-700 hover:bg-accent hover:bg-gr-200',
        outline:
          'border text-gr-700 border-gr-100 hover:bg-gr-100 active:bg-white disabled:text-gr-300 disabled:bg-white',
        link: 'underline-offset-4 hover:underline text-point-500',
        ivory: 'bg-primary-100 text-point-500 hover:bg-primary-200 disabled:text-gr-300',
        point_default: 'bg-point-500 hover:bg-point-700 disabled:bg-gr-200 active:bg-point-500',
      },
      // TODO hight 너무 다양해서 정의하기 어려움..
      size: {
        default: 'h-10 px-4',
        sm: 'h-9 px-3 rounded-md',
        lg: 'h-11 px-8 rounded-md',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  },
);

export type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> &
  VariantProps<typeof buttonVariants> & {
    isLoading?: boolean;
    loadingClassName?: string;
  };

/**
 * 테스트 설명
 */
const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    { className, loadingClassName, variant, size, isLoading, disabled, children, ...props },
    ref,
  ) => {
    return (
      <button
        className={cn(buttonVariants({ variant, size, className }))}
        ref={ref}
        disabled={isLoading ? true : disabled}
        {...props}
      >
        {isLoading ? (
          <span>
            <Loader2 className={cn('mr-2 w-[16px] animate-spin', loadingClassName)} />
          </span>
        ) : null}
        {children}
      </button>
    );
  },
);

Button.displayName = 'Button';

export default Button;
